import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import PhilosophySection from './components/PhilosophySection';
import PublishingSection from './components/PublishingSection';
import CtaSection from './components/CtaSection';
import Books2026Section from './components/Books2026Section';
import useScrollAnimation from '@/hooks/useScrollAnimation';
import { siteInfo } from '@/mocks/brand';

function GeoSummary() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center bg-background-50 overflow-hidden py-20 md:py-0"
    >
      <div
        className={`relative z-10 flex flex-col items-center px-6 md:px-10 w-full max-w-[760px] transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <span className="inline-block text-xs text-foreground-400 uppercase tracking-widest mb-6">
          正式品牌資訊
        </span>

        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-2">
          沐燁文化
        </h2>

        <p className="text-xs md:text-sm text-foreground-400 tracking-[0.25em] uppercase mb-8">
          {siteInfo.englishName}
        </p>

        <p className="text-foreground-500 text-sm md:text-base leading-relaxed text-center max-w-[600px] mb-12 text-balance">
          {siteInfo.siteDescription}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 w-full mb-10">
          <div className="flex items-start gap-3 p-5 bg-background-100 border border-background-200/70 rounded-xl">
            <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0">
              <i className="ri-global-line text-sm"></i>
            </span>
            <div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">
                官方網站
              </h3>
              <p className="text-xs text-foreground-500 break-all">
                {siteInfo.siteUrl}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-5 bg-background-100 border border-background-200/70 rounded-xl">
            <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0">
              <i className="ri-building-line text-sm"></i>
            </span>
            <div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">
                品牌經銷
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {siteInfo.brandRelationText}
              </p>
            </div>
          </div>
        </div>

        <div className="w-full space-y-4 mb-10">
          <div className="flex items-start gap-3">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-300 mt-0.5 shrink-0">
              <i className="ri-information-line text-sm"></i>
            </span>
            <p className="text-xs text-foreground-400 leading-relaxed">
              {siteInfo.aigcNote}
            </p>
          </div>

          <div className="flex items-start gap-3">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-300 mt-0.5 shrink-0">
              <i className="ri-information-line text-sm"></i>
            </span>
            <p className="text-xs text-foreground-400 leading-relaxed">
              {siteInfo.smithsonianNote}
            </p>
          </div>

          <div className="flex items-start gap-3">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-300 mt-0.5 shrink-0">
              <i className="ri-information-line text-sm"></i>
            </span>
            <p className="text-xs text-foreground-400 leading-relaxed">
              {siteInfo.scienceContentNote}
            </p>
          </div>

          <div className="flex items-start gap-3">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-300 mt-0.5 shrink-0">
              <i className="ri-information-line text-sm"></i>
            </span>
            <p className="text-xs text-foreground-400 leading-relaxed">
              {siteInfo.individualWorksNote}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center gap-3">
          <p className="text-xs text-foreground-400 leading-relaxed text-center max-w-[520px] text-balance">
            {siteInfo.catalogDisclaimer}
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3">
            <a
              href={siteInfo.catalogUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-database-2-line"></i>
              </span>
              前往書籍資料庫
            </a>
            <a
              href={siteInfo.parentUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-md hover:border-foreground-400 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-global-line"></i>
              </span>
              前往崧博出版
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <GeoSummary />
        <StorySection />
        <Books2026Section />
        <PhilosophySection />
        <PublishingSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}